import _ from 'lodash'
import store from '../../../index'
import NotificationService from '../../../../services/notificationService';
import {
    CHANGE_PROGRESS,
    FULFILL_CASE_DRAFTS,
    FULLFILL_AVAILABLE_SYSTEM_IDS,
    FULLFILL_CURRENT_SYSTEM_ID,
    FULLFILL_CASES,
    FULLFILL_EDITED_CASE,
    CREATE_REPORT_IN_EDITED_CASE,
    UPDATE_REPORT_IN_EDITED_CASE,
    UPDATE_SUITABLE_BATCH,
    RESET_PAGE,
    CHANGE_FILTER_VALUE,
    ADD_SPECIALIST_TO_REPORT,
    DELETE_SPECIALIST_FROM_REPORT,
    UPDATE_REPORT_SIGNATURE,
    CHANGE_PAGINATION,
    UPDATE_REPORT_FILES,
    CHANGE_REPORT_VALIDATED,
    FULLFILL_REPORTS_IN_EDITED_CASE,
    FULLFILL_REPORT_SAMPLE_TEMPLATES,
    SET_VALIDATION_ERRORS, SET_PATIENT_CONTEXT
} from '../mutations/available'
import api from '../api'
import {extractValidationErrors, extractCommonBackendError, extractUserErrorMessage} from '../../../../helpers/api'


export const setPatientContext = ({state, commit}, patient) => {
    commit(SET_PATIENT_CONTEXT, patient)
}

export const updateAvailableSystemIds = ({state, dispatch, commit}, newAvailableSystemIds) => {
    const localStorage = _.get(store, ['$app', '$localStorage'], null)

    commit(FULLFILL_AVAILABLE_SYSTEM_IDS, newAvailableSystemIds)

    if (localStorage) {
        localStorage.set('availableSystemIds', newAvailableSystemIds)
    }
}

export const changeSearchStringFilter = ({state, dispatch, commit}, searchString) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'searchString',
        value: searchString
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeCreatedFromFilter = ({state, dispatch, commit}, date) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'createdFrom',
        value: date
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeCreatedToFilter = ({state, dispatch, commit}, date) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'createdTo',
        value: date
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeClientsFilter = ({state, dispatch, commit}, clientIds) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'clientIds',
        value: clientIds
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeBatchFilter = ({state, dispatch, commit}, batchId) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'batchId',
        value: batchId
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeNeedSignByFilter = ({state, dispatch, commit}, specialistId) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'needSignBy',
        value: specialistId
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeShowCasesWithoutDocumentsFilter = ({state, dispatch, commit}, value) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'showCasesWithoutDocuments',
        value: value
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeStrictSearchFilter = ({state, dispatch, commit}, strictSearch) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'strictSearch',
        value: strictSearch
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeReportStatusesFilter = ({state, dispatch, commit}, reportStatuses) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'reportStatuses',
        value: reportStatuses
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const changeSampleStatusesFilter = ({state, dispatch, commit}, sampleStatuses) => {
    commit(CHANGE_FILTER_VALUE, {
        filterName: 'sampleStatuses',
        value: sampleStatuses
    })

    dispatch('resetPage')
    dispatch('getCases')
}

export const resetPage = ({commit}) => {
    commit(RESET_PAGE)
}

export const setCurrentSystemId = async ({state, dispatch, commit}) => {
    if (state.progress.setCurrentSystemId) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'setCurrentSystemId', value: true})
    const systemId = await dispatch('getAvailableSystemId')
    commit(CHANGE_PROGRESS, {context: 'setCurrentSystemId', value: false})

    if (systemId) {
        commit(FULLFILL_CURRENT_SYSTEM_ID, systemId)
    }

}

export const getSuitableBatch = async ({state, dispatch, commit}, samplesCount) => {
    if (state.progress['getSuitableBatch']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getSuitableBatch', value: true})

    commit(UPDATE_SUITABLE_BATCH, {
        batch: null,
        availablePlaces: 0
    })

    try {
        let result = await api.getSuitableBatch(samplesCount)
        commit(UPDATE_SUITABLE_BATCH, {
            batch: result.batch,
            availablePlaces: result.availablePlaces
        })
    } catch (e) {
        NotificationService.error(`Unable to get suitable batch. Try again later'`)
    }

    commit(CHANGE_PROGRESS, {context: 'getSuitableBatch', value: false})
}

export const checkOverriddenSystemId = async ({state, dispatch, commit}, overriddenSystemId) => {
    let result = false

    try {
        result = await api.checkOverriddenSystemId(overriddenSystemId)
    } catch (e) {
        NotificationService.error('Unable to check case number availability. Try again later')

        return null
    }
    return result
}

export const getAvailableSystemId = async ({state, dispatch, commit, rootGetters}) => {
    let suitableSystemId = null

    if (rootGetters.progress('cases.getSuitableSystemId')) {
        return
    }

    dispatch('startProgress', 'cases.getSuitableSystemId', {
        root: true
    })

    try {
        suitableSystemId = await api.getSuitableSystemId()
    } catch (e) {
        NotificationService.error('Unable to get case systemId')
    } finally {
        dispatch('stopProgress', 'cases.getSuitableSystemId', {
            root: true
        })
    }

    return suitableSystemId
}

export const resetEditedCase = async ({state, dispatch, commit}) => {
    commit(FULLFILL_EDITED_CASE, null)
}

export const initEditedCase = async ({state, dispatch, commit}, systemId) => {
    commit(FULLFILL_EDITED_CASE, null)

    let caseIndex = _.findIndex(state.cases, (c) => {
        return c.systemId === parseInt(systemId)
    })

    let resultCase = null

    if (caseIndex >= 0) {
        resultCase = state.cases[caseIndex]
        commit(FULLFILL_EDITED_CASE, resultCase)
    }

    if (resultCase === null) {
        dispatch('getEditedCase', systemId)
    }
}

export const getEditedCase = async ({state, dispatch, commit}, systemId) => {
    if (state.progress['getEditedCase']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getEditedCase', value: true})
    try {
        let resultCase = await api.getCase(systemId)

        commit(FULLFILL_EDITED_CASE, resultCase)
    } catch (e) {
        NotificationService.error(`Unable to get edited case. Try again later`)
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getEditedCase', value: false})
}

export const createCase = async ({state, dispatch, commit}, caseData) => {
    if (state.progress['createCase']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'createCase', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'createCase',
        value: {}
    })

    let createdCase = false
    try {
        createdCase = await api.createCase(caseData)
        NotificationService.success(`Case ${createdCase.systemId} was successfully created`)
        if (caseData.overriddenSystemId) {
            dispatch('updateAvailableSystemIds', [])
        }
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        NotificationService.error(`Unable to create case. Try again later`)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'createCase',
                value: validationErrors
            })
        }
    }

    commit(CHANGE_PROGRESS, {context: 'createCase', value: false})

    return createdCase
}

export const updateCase = async ({state, dispatch, commit}, caseData) => {
    if (state.progress['updateCase']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'updateCase', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'updateCase',
        value: {}
    })

    let updatedCase = null
    try {
        updatedCase = await api.updateCase(caseData)
        if (caseData.overriddenSystemId) {
            NotificationService.success(`Case ${caseData.systemId} (${caseData.overriddenSystemId}) was successfully updated`)
            dispatch('updateAvailableSystemIds', [])
        } else {
            NotificationService.success(`Case ${caseData.systemId} was successfully updated`)
        }

        commit(FULLFILL_EDITED_CASE, updatedCase)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)
        NotificationService.error(extractCommonBackendError(e, `Unable to update case. Try again later`))

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'updateCase',
                value: validationErrors
            })
        }
    }

    commit(CHANGE_PROGRESS, {context: 'updateCase', value: false})

    return updatedCase
}

export const changePagination = async ({state, dispatch, commit}, pagination) => {
    commit(CHANGE_PAGINATION, pagination)
    dispatch('getCases')
}

export const getCases = async ({state, dispatch, commit}, caseData) => {
    if (state.progress['getCases']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getCases', value: true})
    const {page, itemsPerPage, sortBy, sortDesc} = state.pagination

    const sortBySingle = _.get(sortBy, 0, null)
    const sortDescSingle = _.get(sortDesc, 0, false)
    let order = null

    if (sortBySingle !== null) {
        order = 'ASC'

        if (sortDescSingle) {
            order = 'DESC'
        }
    }

    try {
        let resultFilters = {
            ...state.filters,
        }

        let result = await api.getCases((page - 1) * itemsPerPage, itemsPerPage, resultFilters, sortBySingle, order)
        commit(FULLFILL_CASES, {
            cases: result.cases,
            casesTotal: result.total
        })
    } catch (e) {
        NotificationService.error(`Unable to get cases. Try again later'`)
    }

    commit(CHANGE_PROGRESS, {context: 'getCases', value: false})
}

export const getCasesByPatient = async ({state, dispatch, commit}, patientId) => {
    let cases = false

    try {
        cases = await api.getCasesByPatient(patientId)
    } catch (e) {
        NotificationService.error(`Unable to get cases by patient. Try again later'`)
    }

    return cases
}

export const createReport = async({state, dispatch, commit}, reportData) => {
    if (state.progress['createReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'createReport', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'createReport',
        value: {}
    })

    let createdReport = false
    try {
        createdReport = await api.createReport(reportData)
        NotificationService.success(`Report was successfully created'`)

        commit(CREATE_REPORT_IN_EDITED_CASE, createdReport)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'createReport',
                value: validationErrors
            })
        } else {
            NotificationService.error(extractCommonBackendError(e, `Unable to report case. Try again later`))
        }
    }

    commit(CHANGE_PROGRESS, {context: 'createReport', value: false})

    return createdReport
}

export const copyReport = async({state, dispatch, commit}, reportId) => {
    if (state.progress['copyReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'copyReport', value: true})

    let copiedReport = false
    try {
        copiedReport = await api.copyReport(reportId)
        NotificationService.success(`Report was successfully copied'`)

        commit(CREATE_REPORT_IN_EDITED_CASE, copiedReport)
    } catch (e) {
         NotificationService.error(extractCommonBackendError(e, `Unable to copy report. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'copyReport', value: false})

    return copiedReport
}

export const updateReport = async({state, dispatch, commit}, reportData) => {
    if (state.progress['updateReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'updateReport', value: true})
    commit(SET_VALIDATION_ERRORS, {
        context: 'updateReport',
        value: {}
    })

    let updatedReport = false
    try {
        updatedReport = await api.updateReport(reportData)
        NotificationService.success(`Report was successfully updated'`)
        commit(UPDATE_REPORT_IN_EDITED_CASE, updatedReport)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_VALIDATION_ERRORS, {
                context: 'updateReport',
                value: validationErrors
            })
        } else {
            NotificationService.error(extractCommonBackendError(e, `Unable to report case. Try again later`))
        }
    }

    commit(CHANGE_PROGRESS, {context: 'updateReport', value: false})

    return updatedReport
}

export const deleteReport = async({state, dispatch, commit}, reportId) => {
    if (state.progress['deleteReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'deleteReport', value: true})

    let reportDeleted = false
    try {
        const newReports = await api.deleteReport(reportId)
        NotificationService.success(`Report was successfully deleted'`)

        commit(FULLFILL_REPORTS_IN_EDITED_CASE, newReports)
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to delete report. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'deleteReport', value: false})

    return reportDeleted
}

export const actualizeReportData = async({state, dispatch, commit, rootGetters}, {reportId, reason}) => {
    if (rootGetters.progress('pgtReports.actualizeReportData')) {
        return
    }

    dispatch('startProgress', 'pgtReports.actualizeReportData', {
        root: true
    })

    let actualized = false

    try {
        const report = await api.actualizeReportData(reportId, reason)
        NotificationService.success(`Report data was successfully actualized'`)

        commit(UPDATE_REPORT_IN_EDITED_CASE, report)

        actualized = true
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to actualize report data. Try again later`))
    } finally {
        dispatch('stopProgress', 'pgtReports.actualizeReportData', {
            root: true
        })
    }

    return actualized
}

export const downloadReport = async({state, dispatch, commit}, {reportId, format, withoutSignatures = false, withoutStamp = false}) => {
    if (state.progress['downloadReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'downloadReport', value: true})

    let report = false

    try {
        report = await api.downloadReport(reportId, format, withoutSignatures, withoutStamp)
    } catch (e) {
        console.log(`Unable to download report, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'downloadReport', value: false})

    return report
}

export const addSpecialistToReport = async({state, dispatch, commit}, {reportId, specialistId}) => {
    if (state.progress['addSpecialistToReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'addSpecialistToReport', value: true})

    let added = false
    try {
        const reportSpecialist = await api.addSpecialistToReport(reportId, specialistId)

        commit(ADD_SPECIALIST_TO_REPORT, {
            reportId: reportId,
            specialist: reportSpecialist
        })
        added = true

    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to add specialist to report. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'addSpecialistToReport', value: false})

    return added
}

export const deleteSpecialistFromReport = async({state, dispatch, commit}, {reportId, specialistId}) => {
    if (_.get(state.progress.deleteSpecialistFromReport, specialistId, false)) {
        return
    }

    commit(CHANGE_PROGRESS, {context: ['deleteSpecialistFromReport', specialistId], value: true})
    let deleted = false

    try {
        const result = await api.deleteSpecialistFromReport(reportId, specialistId)

        commit(DELETE_SPECIALIST_FROM_REPORT, {
            reportId: reportId,
            specialistId: specialistId
        })

        commit(CHANGE_REPORT_VALIDATED, {
            reportId,
            validated: _.get(result, 'validated', false)
        })

        deleted = true
    } catch (e) {
        console.log(`Unable to delete specialist from report, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: ['deleteSpecialistFromReport', specialistId], value: false})

    return deleted
}

export const signReport = async({state, dispatch, commit}, {reportId, specialistId}) => {
    if (state.progress['signReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'signReport', value: true})

    try {
        const reportSignatureData = await api.signReport(reportId, specialistId)
        commit(UPDATE_REPORT_SIGNATURE, {
            reportId,
            specialistSignature: _.get(reportSignatureData, 'specialistSignature', null),
            validated: _.get(reportSignatureData, 'validated', false)
        })
    } catch (e) {
        console.log(`Unable to sign report, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'signReport', value: false})
}

export const deleteSignFromReport = async({state, dispatch, commit}, {reportId, specialistId}) => {
    if (state.progress['deleteSignFromReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'deleteSignFromReport', value: true})

    try {
        const reportSignatureData = await api.deleteSignFromReport(reportId, specialistId)
        commit(UPDATE_REPORT_SIGNATURE, {
            reportId,
            specialistSignature: _.get(reportSignatureData, 'specialistSignature', null),
            validated: _.get(reportSignatureData, 'validated', false)
        })
    } catch (e) {
        console.log(`Unable to delete sign from report, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'deleteSignFromReport', value: false})
}

export const sendReport = async({state, dispatch, commit}, reportId) => {
    if (state.progress['sendReport']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'sendReport', value: true})

    let sentReport = false

    try {
        sentReport = await api.sendReport(reportId)

        commit(UPDATE_REPORT_IN_EDITED_CASE, sentReport)
    } catch (e) {
        NotificationService.error(extractCommonBackendError(e, `Unable to send report. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'sendReport', value: false})

    return sentReport
}

export const addFileToReport = async({state, dispatch, commit}, {reportId, fileId}) => {
    try {
        const files = await api.addFileToReport(reportId, fileId)
        commit(UPDATE_REPORT_FILES, {
            reportId,
            files: files,
        })
    } catch (e) {
        NotificationService.error(extractCommonBackendError(e, `Unable to add file to report. Try again later`))
    }
}

export const deleteFileFromReport = async({state, dispatch, commit}, {reportId, fileId}) => {
    try {
        const files = await api.deleteFileFromReport(reportId, fileId)
        commit(UPDATE_REPORT_FILES, {
            reportId,
            files: files,
        })
    } catch (e) {
        NotificationService.error(extractCommonBackendError(e, `Unable to delete file from report. Try again later`))
    }
}

export const afterApplicationInit = {
    root: true,
    async handler(namespacedContext, payload) {
        const reportSampleTemplates = _.get(payload, 'reportSampleTemplates', [])
        namespacedContext.commit(FULLFILL_REPORT_SAMPLE_TEMPLATES, reportSampleTemplates)

        const localStorage = _.get(store, ['$app', '$localStorage'], null)

        if (!localStorage) {
            NotificationService.error("Unable to get storage from browser, drafts will not available")
        }

        localStorage.addProperty('caseDrafts', Object, {})
        localStorage.addProperty('availableSystemIds', Array, [])

        const availableSystemIds = localStorage.get('availableSystemIds')
        const caseDrafts = localStorage.get('caseDrafts')

        namespacedContext.commit(FULLFILL_AVAILABLE_SYSTEM_IDS, availableSystemIds)
        namespacedContext.commit(FULFILL_CASE_DRAFTS, caseDrafts)
    }
}
